module.exports = __webpack_public_path__ + "media/images/top/simple-arrow-3b227ae0625b3c2ed4e7260821408a5e.png";